const state = {
  loadings: {
    main: 0,
    currentHomeworkExercise: false, // no concurrent loading activations in specific cases
  },
};

const getters = {
  isLoading: (state) => {
    return state.loadings.main > 0;
  },
  isCurrentHomeworkExerciseLoading: (state) => {
    return state.loadings.currentHomeworkExercise;
  },
};

const actions = {
  enableLoadings({ commit }) {
    commit("SET_LOADINGS", true);
  },
  disableLoadings({ commit }) {
    commit("SET_LOADINGS", false);
  },
  enableCurrentExerciseLoading({ commit }) {
    commit("SET_CURRENT_EXERCISE_LOADING", true);
  },
  disableCurrentExerciseLoading({ commit }) {
    commit("SET_CURRENT_EXERCISE_LOADING", false);
  },
};

const mutations = {
  SET_LOADINGS(state, loadingsState) {
    if (loadingsState) {
      state.loadings.main += 1;
    }
    if (!loadingsState && state.loadings.main > 0) {
      state.loadings.main -= 1;
    }
  },
  SET_CURRENT_EXERCISE_LOADING(state, loadingsState) {
    state.loadings.currentHomeworkExercise = loadingsState;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
